<template>
  <b-card-text :class="!hideMailIcon ? 'hide-mail-icon' : ''">
    <el-autocomplete
      v-model="query"
      class="inline-input"
      :fetch-suggestions="verify"
      :placeholder="$t('search_user_place_holder')"
      :trigger-on-focus="false"
      size="small"
      @select="handleSelect"
    ></el-autocomplete>

    <b-alert v-if="invalidUserFeedback" show variant="danger">
      <div class="alert-body">
        <span>
          <strong>{{ invalidUserFeedback }}</strong>
        </span>
      </div>
    </b-alert>
  </b-card-text>
</template>
<script>
import Vue from 'vue'
import { Autocomplete } from 'element-ui'
import { BCardText, BAlert } from 'bootstrap-vue'
import { mapState } from 'vuex'
Vue.use(Autocomplete)

export default {
  components: {
    BCardText,
    BAlert
  },
  props: {
    hideMailIcon: {
      type: Boolean
    }
  },
  data: function() {
    return {
      isEmail: false,
      email: '',
      query: '',
      invalidUserFeedback: ''
    }
  },
  computed: {
    ...mapState('permission', ['searchResults', 'entityType']),
    ...mapState('homeAddNew', ['entityType'])
  },
  mounted() {
    this.email = ''
    this.query = ''
  },
  destroyed() {
    this.email = ''
    this.query = ''
  },
  methods: {
    verify(queryString, cb) {
      this.$emit('input', queryString)
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      this.email = ''
      this.invalidUserFeedback = ''
      this.$store
        .dispatch('permission/searchUser', {
          self: this,
          searchText: queryString,
          pageNo: 1,
          itemsPerPage: 10
        })
        .then(res => {
          if (res.length > 0) {
            this.invalidUserFeedback = ''
            res.forEach(u => {
              if (u.firstName === u.lastName) {
                u.value = u.email
              } else {
                u.value = `${u.firstName} ${u.lastName} - ${u.email}`
              }
            })
            cb(res)
          } else {
            this.invalidUserFeedback = ''

            if (re.test(queryString)) {
              this.email = queryString
              const user = {
                email: queryString
              }
              this.$emit('update:isEmail', user)
            } else {
              this.invalidUserFeedback = 'Email address is invalid'
              this.$emit('update:isEmail', false)
            }

            cb([])
          }
        })
    },
    handleSelect(user) {
      this.email = user.email
      this.$emit('update:isEmail', user)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables/_variables';

.card-text {
  width: 100%;
}

.mail-icon {
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}

.hide-mail-icon {
  padding-right: 5px;
}

.el-autocomplete {
  width: 100%;
}

.alert {
  margin-top: 1rem;
}
</style>
